module.exports = __webpack_public_path__ + "img/TJ.75b57bdb.svg";